import { usePlatformStore, TOOLS } from '@/stores/platformStore'

export function SmithyHeader({ children }: { children?: React.ReactNode }) {
  const activeTool = usePlatformStore((s) => s.activeTool)
  const tool = TOOLS.find((t) => t.id === activeTool)

  return (
    <header className="h-12 flex items-center px-5 bg-forge-obsidian border-b border-forge-border gap-4">
      <h1 className="font-display font-bold text-sm text-forge-primary">
        {tool ? (
          <>
            {tool.name}
            <span className="ml-2 text-forge-ash font-normal">{tool.description}</span>
          </>
        ) : (
          <>
            Smithy
            <span className="ml-2 text-forge-ash font-normal">The Forge Platform</span>
          </>
        )}
      </h1>
      <div className="flex-1" />
      {children}
    </header>
  )
}
